<!-- New Filter Toolbar -->
<div class="filter-toolbar">
  <div class="filter-bar">
    <div class="search-container">
      <div class="search-input-wrapper">
        <input type="text" class="filter-search-input" placeholder="Search" [formControl]="searchControl" aria-label="Search items by key, name, or description" />
        @if (searchControl.value && searchControl.value.length > 0) {
        <button type="button" class="search-clear-button" matTooltip="Clear search" matTooltipPosition="above" (click)="onSearchClear()" aria-label="Clear search">
          <mat-icon>close</mat-icon>
        </button>
        }
      </div>
    </div>
    <div class="all-filters">
      <!-- Default filters (always visible) -->
      @for (filter of defaultFilters; track trackByFilterId($index, filter)) {
      <app-base-filter
        [config]="filter"
        [value]="getActiveFilterValue(filter.field)"
        [isActive]="isFilterActive(filter.field)"
        [isCompact]="false"
        [isCurrentlyOpen]="currentOpenDropdown === filter.field"
        (filterChange)="onFilterChange($event)"
        (filterRemove)="onFilterRemove($event)"
        (filterActivate)="onFilterActivate($event)"
        (filterDropdownToggle)="onFilterDropdownToggle($event)"
        class="filter-item">
      </app-base-filter>
      }

      <!-- Active "more" filters (added from More Filters dropdown) -->
      @for (moreFilter of getActiveMoreFilters(); track trackByFilterId($index, moreFilter)) {
      <app-base-filter
        [config]="moreFilter"
        [value]="getActiveFilterValue(moreFilter.field)"
        [isActive]="isFilterActive(moreFilter.field)"
        [isCompact]="false"
        [isCurrentlyOpen]="currentOpenDropdown === moreFilter.field"
        [isFromMoreFilters]="true"
        (filterChange)="onFilterChange($event)"
        (filterRemove)="onFilterRemove($event)"
        (filterActivate)="onFilterActivate($event)"
        (filterDropdownToggle)="onFilterDropdownToggle($event)"
        class="filter-item">
      </app-base-filter>
      }

      <!-- More Filters Dropdown -->
      <app-more-filters [availableFilters]="moreFilters" [activeFilterIds]="activeFilterIds" (filterAdd)="onAddMoreFilter($event)"> </app-more-filters>

      @if (activeFilters.length > 0) {
      <button mat-button class="clear-filters-button" (click)="onClearAllFilters()" matTooltip="Clear all filters">
        <mat-icon>clear</mat-icon>
      </button>
      }
    </div>
  </div>
</div>
